import { IProduct } from '../models/product'
import Api from './index'

export const getProducts = () => Api<IProduct[]>('GET', 'products')

export const getProduct = (id: IProduct['id']) =>
  Api<IProduct>('GET', `products/${id}`)
